module.exports = __webpack_public_path__ + "img/job_01.c19158bc.jpg";